import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { observer } from 'mobx-react';

import ThemeService from 'themes/ThemeService';
import { translate } from 'services/i18nService';
import UserStore from 'stores/UserStore';
import Hyperlink from 'components/Hyperlink/Hyperlink';
import { GENDER } from 'enum/profile';
import routeDefinitions from 'enum/routeDefinitions';
import { generateID } from 'utils/helpers';

import flags from '../../../../../images/logo/flags_new.png';

import styles from './index.css';


const IDS = {
  prefix: 'D7G9Q5UJ',
  element: 'logo',
};
const makeId = generateID(IDS.prefix, IDS.element);

const Logo = (props) => {
  const { isStudioOwner, isStudioAdmin } = props;

  const {
    user: {
      genderPreference: userPref,
      realCountry,
    },
  } = UserStore;

  const countryFlag = realCountry || 'unknown';

  const href = useMemo(() => {
    let genderPreference = userPref;
    if (userPref === GENDER.SHEMALE) {
      genderPreference = GENDER.TRANSGENDER;
    }

    let result = UserStore.defaultPage;
    if (isStudioOwner || isStudioAdmin) {
      result = routeDefinitions.studioDashboard;
    } else if (genderPreference) {
      result = routeDefinitions.get(routeDefinitions.directory, { genderPreference });
    }

    return result;
  }, [isStudioAdmin, isStudioOwner, userPref]);

  const flagElement = useMemo(() => {
    const flagClasses = classnames(
      styles.flag,
      styles[`flag-${countryFlag}`]
    );

    const flagStyle = { backgroundImage: `url("${flags}")` };

    return (
      <div className={styles.flags}>
        <div
          className={flagClasses}
          style={flagStyle}
        />
      </div>
    );
  }, [countryFlag]);

  return (
    <Hyperlink
      className={styles.logo}
      href={href}
      id={makeId()}
    >
      <img
        alt={translate('verification.verification.logo.alt')}
        className={styles.logoImage}
        height={23}
        src={ThemeService.theme.logoImage}
        width={110}
      />
      {flagElement}
    </Hyperlink>
  );
};

Logo.propTypes = {
  isStudioAdmin: PropTypes.bool,
  isStudioOwner: PropTypes.bool,
};

Logo.defaultProps = {
  isStudioAdmin: false,
  isStudioOwner: false,
};

export default observer(Logo);
